/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  window.addEventListener('click', function(event) {
    if (!(event.target instanceof Element)) {
      return;
    }

    var openButton = event.target.closest('.product-soldout-notification [data-popup-open]');
    var closeButton = event.target.closest('.product-soldout-notification [data-popup-close]');
    var popup = event.target.closest('.product-soldout-notification');
    var dialog = popup?.querySelector('dialog');

    if (!dialog || (!openButton && !closeButton)) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    if (openButton) {
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }

      dialog.removeAttribute('inert');
      dialog.setAttribute('aria-hidden', 'false');
      dialog.querySelector('input[type="email"]')?.focus();
      return;
    }

    dialog.close();
    dialog.setAttribute('inert', '');
    dialog.setAttribute('aria-hidden', 'true');
  }, true);
})();

(function() {
  var committedCardImages = new WeakMap();

  function getCardImage(card) {
    return card?.querySelector('[data-product-image-default] img') || null;
  }

  function readCardImage(image) {
    return {
      src: image.getAttribute('src') || '',
      srcset: image.getAttribute('srcset') || ''
    };
  }

  function writeCardImage(image, source) {
    if (!image || !source?.src) return;

    image.src = source.src;
    if (source.srcset) {
      image.srcset = source.srcset;
    } else {
      image.removeAttribute('srcset');
    }
  }

  function rememberCommittedCardImage(card) {
    if (!card || committedCardImages.has(card)) return;

    var image = getCardImage(card);
    if (image) committedCardImages.set(card, readCardImage(image));
  }

  function previewColourImage(colourButton) {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var card = colourButton.closest('.alaia-editorial-card');
    var image = getCardImage(card);
    var nextImage = colourButton.dataset.productImage || '';
    if (!card || !image || !nextImage) return;

    rememberCommittedCardImage(card);
    card.classList.add('is-colour-previewing');
    writeCardImage(image, {src: nextImage, srcset: nextImage});
  }

  function restoreCommittedCardImage(card) {
    var image = getCardImage(card);
    var committedImage = card ? committedCardImages.get(card) : null;
    card?.classList.remove('is-colour-previewing');
    if (image && committedImage) writeCardImage(image, committedImage);
  }

  function commitCardImage(card, nextImage) {
    var image = getCardImage(card);
    if (!card || !image || !nextImage) return;

    var committedImage = {src: nextImage, srcset: nextImage};
    writeCardImage(image, committedImage);
    committedCardImages.set(card, committedImage);
  }

  function initCardControls(root) {
    var interactiveSelector = [
      '[data-alaia-card-toggle]',
      '.alaia-card-panel a',
      '.alaia-card-panel button',
      '.alaia-card-panel summary',
      '.alaia-card-panel select',
      '.alaia-card-colour-preview button'
    ].join(', ');

    (root || document).querySelectorAll(interactiveSelector).forEach(function(control) {
      if (control.dataset.alaiaDragGuardReady === 'true') return;
      control.dataset.alaiaDragGuardReady = 'true';
      control.addEventListener('mousedown', function(event) {
        event.stopPropagation();
      });
    });
  }

  function closeCardPanels(except) {
    document.querySelectorAll('.alaia-editorial-card.is-panel-open').forEach(function(card) {
      if (card === except) return;
      card.classList.remove('is-panel-open');
      card.querySelector('[data-alaia-card-toggle]')?.setAttribute('aria-expanded', 'false');
      if (card.classList.contains('alaia-collection-card')) {
        card.querySelector('[data-alaia-card-panel]')?.setAttribute('inert', '');
        if (card.contains(document.activeElement)) card.querySelector('[data-alaia-card-toggle]')?.focus();
      }
    });
  }

  document.addEventListener('click', function(event) {
    if (!(event.target instanceof Element)) return;

    if (event.target.closest('[data-alaia-card-close]')) {
      closeCardPanels();
      return;
    }

    var toggle = event.target.closest('[data-alaia-card-toggle]');
    if (toggle) {
      event.preventDefault();
      if (toggle.disabled) return;
      var card = toggle.closest('.alaia-editorial-card');
      var willOpen = !card.classList.contains('is-panel-open');
      closeCardPanels(card);
      card.classList.toggle('is-panel-open', willOpen);
      toggle.setAttribute('aria-expanded', String(willOpen));
      if (card.classList.contains('alaia-collection-card')) {
        card.querySelector('[data-alaia-card-panel]')?.toggleAttribute('inert', !willOpen);
        if (willOpen) card.querySelector('[data-alaia-size-summary]')?.focus();
      }
      return;
    }

    var sizeOption = event.target.closest('[data-alaia-size-option]');
    if (sizeOption) {
      event.preventDefault();
      if (sizeOption.disabled || sizeOption.hidden) return;

      var form = sizeOption.closest('form');
      var dropdown = sizeOption.closest('[data-alaia-size-dropdown]');
      var variantInput = form?.querySelector('[data-alaia-card-variant]');
      var addButton = form?.querySelector('[data-alaia-size-add]');
      var summaryText = dropdown?.querySelector('[data-alaia-size-summary-text]');
      var variantId = sizeOption.dataset.variantId || '';

      form?.querySelectorAll('[data-alaia-size-option]').forEach(function(button) {
        var isSelected = button === sizeOption;
        button.classList.toggle('is-selected', isSelected);
        button.setAttribute('aria-selected', String(isSelected));
      });

      if (variantInput) variantInput.value = variantId;
      if (addButton) {
        addButton.dataset.variantId = variantId;
        addButton.disabled = !variantId;
      }
      if (summaryText) summaryText.textContent = sizeOption.dataset.sizeLabel || sizeOption.textContent.trim();
      if (dropdown) dropdown.open = false;
      return;
    }

    var colourButton = event.target.closest('[data-alaia-colour-select]');
    if (colourButton) {
      event.preventDefault();

      var card = colourButton.closest('.alaia-editorial-card');
      var panel = card?.querySelector('[data-alaia-card-panel]');
      if (!panel || !card) return;

      var colourKey = colourButton.dataset.colourKey || '';
      card.querySelectorAll('[data-alaia-colour-select]').forEach(function(button) {
        var isSelected = button.dataset.colourKey === colourKey;
        button.classList.toggle('is-selected', isSelected);
        button.setAttribute('aria-pressed', String(isSelected));
      });

      var colourName = panel.querySelector('[data-alaia-colour-name]');
      if (colourName) colourName.textContent = colourButton.dataset.colourName || '';

      var sizeDropdown = panel.querySelector('[data-alaia-size-dropdown]');
      var sizeSummary = sizeDropdown?.querySelector('[data-alaia-size-summary-text]');
      var addButton = panel.querySelector('[data-alaia-size-add]');
      var addButtonText = addButton?.querySelector('[data-add-to-cart-text]');
      var colourComingSoon = colourButton.hasAttribute('data-colour-coming-soon');
      var firstAvailableOption = null;
      sizeDropdown?.querySelectorAll('[data-alaia-size-option]').forEach(function(option) {
        var isMatch = option.dataset.colourKey === colourKey;
        option.hidden = !isMatch;
        option.classList.remove('is-selected');
        option.setAttribute('aria-selected', 'false');
        if (isMatch && !option.disabled && !firstAvailableOption) firstAvailableOption = option;
      });

      if (sizeSummary) sizeSummary.textContent = sizeDropdown.dataset.placeholder || 'Select size';
      if (sizeDropdown) sizeDropdown.open = false;
      if (addButton) {
        addButton.dataset.variantId = '';
        addButton.disabled = true;
      }
      if (addButtonText) addButtonText.textContent = colourComingSoon ? 'Coming Soon' : 'Add to bag';

      var variantInput = panel.querySelector('[data-alaia-card-variant]');
      if (variantInput && firstAvailableOption) variantInput.value = firstAvailableOption.value;

      var nextUrl = colourButton.dataset.productUrl;
      if (nextUrl) {
        card.querySelectorAll('[data-product-link], [data-alaia-panel-product-link]').forEach(function(link) {
          link.href = nextUrl;
        });
      }

      var nextTitle = colourButton.dataset.productTitle;
      var title = panel.querySelector('[data-alaia-panel-title]');
      if (title && nextTitle) title.textContent = nextTitle;
      var cardTitle = card.querySelector('.product-item__title');
      if (cardTitle && nextTitle) cardTitle.textContent = nextTitle;

      var cardBadge = card.querySelector('[data-alaia-card-badge]');
      if (cardBadge && colourButton.hasAttribute('data-product-badge')) {
        cardBadge.textContent = colourButton.dataset.productBadge || '';
      }

      var nextPrice = colourButton.dataset.productPrice;
      var price = panel.querySelector('[data-alaia-panel-price]');
      if (price && nextPrice) price.textContent = nextPrice;
      var cardPrice = card.querySelector('.product-information [data-product-price]');
      if (cardPrice && nextPrice) cardPrice.textContent = nextPrice;

      var nextImage = colourButton.dataset.productImage;
      if (nextImage) commitCardImage(card, nextImage);

      if (colourButton.closest('.alaia-card-colour-preview')) {
        closeCardPanels(card);
        card.classList.add('is-panel-open');
        card.querySelector('[data-alaia-card-toggle]')?.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    if (!event.target.closest('.alaia-editorial-card')) closeCardPanels();
  });

  document.addEventListener('mouseover', function(event) {
    if (!(event.target instanceof Element)) return;

    var colourButton = event.target.closest('[data-alaia-colour-select]');
    if (colourButton) previewColourImage(colourButton);
  });

  document.addEventListener('mouseout', function(event) {
    if (!(event.target instanceof Element)) return;

    var colourGroup = event.target.closest('.alaia-card-colour-preview, .alaia-card-panel__colours');
    if (!colourGroup) return;
    if (event.relatedTarget instanceof Node && colourGroup.contains(event.relatedTarget)) return;

    restoreCommittedCardImage(colourGroup.closest('.alaia-editorial-card'));
  });

  document.addEventListener('focusin', function(event) {
    if (!(event.target instanceof Element)) return;

    var colourButton = event.target.closest('[data-alaia-colour-select]');
    if (colourButton) previewColourImage(colourButton);
  });

  document.addEventListener('focusout', function(event) {
    if (!(event.target instanceof Element)) return;

    var colourGroup = event.target.closest('.alaia-card-colour-preview, .alaia-card-panel__colours');
    if (!colourGroup) return;
    if (event.relatedTarget instanceof Node && colourGroup.contains(event.relatedTarget)) return;

    restoreCommittedCardImage(colourGroup.closest('.alaia-editorial-card'));
  });

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') closeCardPanels();
  });

  document.addEventListener('DOMContentLoaded', function() {
    initCardControls(document);
  });

  document.addEventListener('shopify:section:load', function(event) {
    initCardControls(event.target);
  });
})();

(function() {
  function enforceComingSoon(root) {
    (root || document).querySelectorAll('[data-coming-soon-button]').forEach(function(button) {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');

      var buttonText = button.querySelector('[data-add-to-cart-text]');
      if (buttonText) buttonText.textContent = button.dataset.comingSoonText || 'Coming Soon';

      var productForm = button.closest('form');
      var variantInput = productForm?.querySelector('.product-variant-id');
      if (variantInput) variantInput.disabled = true;
    });
  }

  function initComingSoon() {
    enforceComingSoon(document);

    if (typeof window.subscribe === 'function' && window.theme?.PUB_SUB_EVENTS?.variantChange) {
      window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function() {
        requestAnimationFrame(function() {
          enforceComingSoon(document);
        });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', initComingSoon);
  document.addEventListener('shopify:section:load', function(event) {
    enforceComingSoon(event.target);
  });
  document.addEventListener('submit', function(event) {
    if (event.target instanceof Element && event.target.querySelector('[data-coming-soon-button]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
})();

(function() {
  function initProductGalleryProgress(root) {
    if (!document.documentElement.classList.contains('template-product')) return;

    (root || document).querySelectorAll('[data-alaia-gallery-progress]').forEach(function(progress) {
      if (progress.dataset.alaiaProgressReady === 'true') return;

      var productImages = progress.closest('product-images');
      var gallery = productImages?.querySelector('[data-product-media-list]');
      var indicator = progress.querySelector('[data-alaia-gallery-progress-indicator]');
      if (!gallery || !indicator) return;

      function updateProgress() {
        var maximumScroll = Math.max(gallery.scrollWidth - gallery.clientWidth, 0);
        var visibleRatio = gallery.scrollWidth ? gallery.clientWidth / gallery.scrollWidth : 1;
        var travelRatio = maximumScroll ? gallery.scrollLeft / maximumScroll : 0;
        var progressValue = Math.min(1, visibleRatio + travelRatio * (1 - visibleRatio));

        indicator.style.width = (progressValue * 100) + '%';
        progress.setAttribute('aria-valuenow', String(Math.round(progressValue * 100)));
      }

      progress.dataset.alaiaProgressReady = 'true';
      gallery.addEventListener('scroll', window.theme.throttle(updateProgress, 16), {passive: true});
      document.addEventListener('theme:resize', updateProgress);
      requestAnimationFrame(updateProgress);
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initProductGalleryProgress(document);
  });

  document.addEventListener('shopify:section:load', function(event) {
    initProductGalleryProgress(event.target);
  });
})();

(function() {
  function initProductRailControls(root) {
    (root || document).querySelectorAll('[data-alaia-product-rail-controls]').forEach(function(controls) {
      if (controls.dataset.alaiaRailReady === 'true') return;

      var scope = controls.closest('.index-products, .tab-content, .alaia-triptych');

      function bindControls() {
        if (controls.dataset.alaiaRailReady === 'true') return true;

        var slider = scope?.querySelector('[data-grid-slider]');
        var previousButton = controls.querySelector('[data-alaia-product-rail-prev]');
        var nextButton = controls.querySelector('[data-alaia-product-rail-next]');
        var progress = controls.querySelector('[data-alaia-product-rail-progress]');
        var indicator = controls.querySelector('[data-alaia-product-rail-indicator]');

        if (!slider || !previousButton || !nextButton || !progress || !indicator) return false;

        function getScrollStep() {
          var items = slider.querySelectorAll('[data-grid-item]');
          if (items.length > 1) return items[1].offsetLeft - items[0].offsetLeft;
          return items[0]?.offsetWidth || slider.clientWidth;
        }

        function updateControls() {
          var maximumScroll = Math.max(slider.scrollWidth - slider.clientWidth, 0);
          var visibleRatio = slider.scrollWidth ? Math.min(slider.clientWidth / slider.scrollWidth, 1) : 1;
          var travelRatio = maximumScroll ? Math.min(Math.max(slider.scrollLeft / maximumScroll, 0), 1) : 0;
          var indicatorWidth = visibleRatio * 100;
          var indicatorPosition = travelRatio * (100 - indicatorWidth);

          controls.classList.toggle('is-ready', maximumScroll > 2);
          previousButton.disabled = slider.scrollLeft <= 2;
          nextButton.disabled = slider.scrollLeft >= maximumScroll - 2;
          indicator.style.width = indicatorWidth + '%';
          indicator.style.transform = 'translateX(' + (indicatorPosition / Math.max(visibleRatio, 0.01)) + '%)';
          progress.setAttribute('aria-valuenow', String(Math.round(travelRatio * 100)));
        }

        function moveRail(direction) {
          slider.scrollTo({
            top: 0,
            left: slider.scrollLeft + getScrollStep() * direction,
            behavior: 'smooth'
          });
        }

        controls.dataset.alaiaRailReady = 'true';
        previousButton.addEventListener('click', function() { moveRail(-1); });
        nextButton.addEventListener('click', function() { moveRail(1); });
        slider.addEventListener('scroll', window.theme.throttle(updateControls, 16), {passive: true});
        document.addEventListener('theme:resize', updateControls);
        new MutationObserver(updateControls).observe(slider, {childList: true});
        requestAnimationFrame(function() {
          requestAnimationFrame(updateControls);
        });

        return true;
      }

      if (bindControls() || !scope) return;

      var scopeObserver = new MutationObserver(function() {
        if (bindControls()) scopeObserver.disconnect();
      });
      scopeObserver.observe(scope, {childList: true, subtree: true});
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initProductRailControls(document);
  });

  document.addEventListener('shopify:section:load', function(event) {
    initProductRailControls(event.target);
  });
})();
